<template>
	<el-row>
		<el-col :span="24">
			<div class="base-form header">
				<h2>График загрузки ресурсов</h2>
			</div>
		</el-col>
	</el-row>

	<el-row>
		<!-- executive entity selector -->
		<el-col :span="4">
			<div class="base-form" style="max-width: unset;">
				<el-form-item label="Организация-исполнитель" label-position="top">
					<el-select
						v-model="selectedExecutiveEntity"
						filterable
						reserve-keyword
						placeholder="Выберите из списка"
						@change="onDatepickerChange"
					>
						<template #label="{ label }">
							<span style="float: left">{{ label }}</span>
						</template>
						<el-option
							v-for="item in executiveEntities"
							:key="item.id"
							:label="item.name"
							:value="item" />
					</el-select>
				</el-form-item>
			</div>
		</el-col>

		<!-- executive entity branch selector -->
		<el-col :span="4">
			<div class="base-form" style="max-width: unset;">			
				<el-form-item label="Подразделение" label-position="top">
					<el-select
						v-model="selectedExecutiveEntityBranch"
						filterable
						reserve-keyword
						placeholder="Выберите из списка"
						:disabled="!selectedExecutiveEntity?.id"
						@change="onLegalEntityBranchChange"
					>
						<template #label="{ label }">
							<span style="float: left">{{ label }}</span>
						</template>
						<el-option
							v-for="item in selectedExecutiveEntity?.branches"
							:key="item.id"
							:label="item.name"
							:value="item" />
					</el-select>
				</el-form-item>	
			</div>
		</el-col>

		<!-- date selector -->
		<el-col :span="4">
			<div class="base-form" style="max-width: unset;">				
				<el-form-item label="Дата отчета" label-position="top">
					<el-date-picker
						@change="onDatepickerChange"
						v-model="timelineDate"
						type="date"
						placeholder=""
						:clearable="false"
					/>
				</el-form-item>
			</div>			
		</el-col>

		<!-- reload button -->
		<el-col :span="12">
			<div class="base-form" style="max-width: unset; text-align: right;">				
				r
			</div>			
		</el-col>
	</el-row>

	<el-row>
		<el-col :span="24">
			<div class="base-form form" style="max-width: unset;" v-if="isReadyToLoadTimelineComponent()">				
				<timeline-component
					:branch="selectedExecutiveEntityBranch?.id"
					:visible="isTimelineVisible"
					:schedule="schedule"
					:scheduleDate="timelineDate"
					@item-clicked="onTimleineItemClicked" 
				/>
				<el-text v-if="isTimelineErrorVisible" type="danger">Ошибка загрузки графика</el-text>
			</div>			
		</el-col>
	</el-row>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import TimelineComponent from '@/components/timeline/TimelineComponent.vue';
import ITimelineItem from '@/components/timeline/models/ITimelineItem';
import store from '@/store';
import EmployeesJobsScheduleApiHelper from '@/helpers/api/EmployeesJobsScheduleApiHelper';
import dateOnlyHelper from '@/helpers/dateOnlyHelper';
import EmployeeJobScheduleModel from '@/models/EmployeeJobScheduleModel';
import LegalEntityModel from '@/models/LegalEntityModel';
import LegalEntityBranchModel from '@/models/LegalEntityBranchModel';

@Options({
	components: {
		TimelineComponent
	}
})
export default class ScheduleView extends Vue {	
	/** view-models */
	selectedExecutiveEntity: LegalEntityModel | null = null;
	selectedExecutiveEntityBranch: LegalEntityBranchModel | null = null;
	
	executiveEntities: Array<LegalEntityModel> | null = null;
		
	schedule: Array<EmployeeJobScheduleModel> | null = null;
	
	timelineDate: Date | null = new Date();
	isTimelineVisible = false;	
	isTimelineErrorVisible = false;

	mounted(): void {
		this.executiveEntities = store.getters.executives;

		if (this.executiveEntities?.length == 1) {
			this.selectedExecutiveEntity = this.executiveEntities[0];

			if (this.selectedExecutiveEntity.branches?.length == 1) {
				this.selectedExecutiveEntityBranch = this.selectedExecutiveEntity.branches[0];
				this.$nextTick().then(() => this.loadTimelineAsync());
			}
		}
	}
	
	onLegalEntityChange() {
		this.selectedExecutiveEntityBranch = null;
	}

	onLegalEntityBranchChange() {
		this.loadTimelineAsync();
	}

	onDatepickerChange() {		
		this.loadTimelineAsync();
	}

	onTimleineItemClicked(item: ITimelineItem) {
		console.log('clicked timeline item:', item);
	}

	loadJobsSchedule(branchId: number, date: Date) {
		const employeesJobsScheduleApi = new EmployeesJobsScheduleApiHelper();
		
		return employeesJobsScheduleApi.getJobsSchedule(
			branchId, 
			dateOnlyHelper.date(date),
			store.getters.jwt
		);
	}

	isReadyToLoadTimelineComponent() : boolean {
		return !!this.selectedExecutiveEntityBranch?.id && !!this.timelineDate;
	}

	loadTimelineAsync() {
		if (!this.isReadyToLoadTimelineComponent()) {
			this.isTimelineVisible = false;
			this.isTimelineErrorVisible = false;
			return;
		}

		this.isTimelineVisible = false;
		this.isTimelineErrorVisible = false;
		this.loadJobsSchedule(this.selectedExecutiveEntityBranch!.id, this.timelineDate!)
			.then((schedule) => {			
				this.schedule = schedule;
				this.$nextTick()
					.then(() => this.isTimelineVisible = true);
			}).catch(() => {
				this.isTimelineVisible = false;
				this.isTimelineErrorVisible = true;
			});

	}
}
</script>